import {
  Box,
  createStyles,
  Divider, Drawer,
  Hidden,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import { DrawerContextConsumer, ListItemLinkProps } from 'contexts/DrawerContext';
import React from 'react';
import {
  Link, NavLink, Route, useLocation
} from 'react-router-dom';
import { theme as dna } from 'theme';


const ListItemLink = (props: ListItemLinkProps) => {
  const { Icon, primary, to } = props;
  const location = useLocation();
  const active = location.pathname.startsWith(to);
  const renderLink = React.useMemo(
    () => React.forwardRef<any, any>((itemProps, ref) => (
      <NavLink
        exact
        to={to}
        ref={ref}
        {...itemProps}
      />
    )),
    [to],
  );

  return (
    <li>
      <ListItem button component={renderLink}>
        {Icon ? <ListItemIcon><Icon color={active ? 'primary' : 'inherit'} /></ListItemIcon> : null}
        <ListItemText primary={(
          <Typography variant="body2" color={active ? 'primary' : 'inherit'}>
            <Box fontWeight={active ? 600 : 400} component="span">
              {primary}
            </Box>
          </Typography>
      )}
        />
      </ListItem>
    </li>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: 300,
      flexShrink: 0,
    },
  }
}),);

export const BtcsDrawer = (props: any) => {
  const { window } = props;
  const container = window !== undefined ? () => window().document.body : undefined;
  const classes = useStyles();

  const DrawerItems = (navItems: ListItemLinkProps[]) => (
    <List>
      {navItems.map((itemProps) => (<ListItemLink key={itemProps.to} {...itemProps} />))}
    </List>
  );

  const FooterItems = (footerItem: any) => (
    <List>
      {footerItem.map((itemProps: any) => (
        <ListItem key={itemProps.to}>
          <ListItemText
            primary={(
              <Typography
                variant="caption"
                color="textPrimary"
                component={Link}
                to={itemProps.to}
                style={{ textDecoration: 'none' }}
              >
                {itemProps.label}
              </Typography>
            )}
          />
        </ListItem>
      ))}
    </List>
  );

  return (
    <DrawerContextConsumer>
      {({
        mobileOpen, handleDrawerToggle, navItems, footerItems
      }) => (
        <Route path={[...navItems.map((item) => item.to), ...footerItems.map((item) => item.to)]}>
          <nav className={classes.drawer}>
            <Hidden mdUp implementation="css">
              <Drawer
                container={container}
                variant="temporary"
                anchor={dna.direction === 'rtl' ? 'right' : 'left'}
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {DrawerItems(navItems)}
              </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
              <Drawer
                variant="permanent"
                open
              >
                <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                  <Box>
                    {DrawerItems(navItems)}
                  </Box>
                  <Box>
                    <Divider />
                    <Box p={4}>
                      {FooterItems(footerItems)}
                    </Box>
                  </Box>
                </Box>
              </Drawer>
            </Hidden>
          </nav>
        </Route>
      )}
    </DrawerContextConsumer>
  );
};
